// extracted by mini-css-extract-plugin
module.exports = {"XIcon":"XIcon_XIcon__xLeN7","icon":"XIcon_icon__q0ntJ","Destination":"XIcon_Destination__2CmH-"};